<template>
  <b-container fluid>
    <div>
      <b-row no-gutters align-v="center" class="menu-item" @click="chooseModal(menuitem)">
        <b-col class="text-left" cols="3">
          <b-img :src="menuitem.image" fluid />
        </b-col>
        <b-col>
          <h5 center>{{menuitem.name}}</h5>
          <h6>{{menuitem.description}}</h6>
          <i v-if="!hasVariants">{{menuitem.price.toFixed(2)}} {{menuitem.currency}}</i>
          <b-row v-else>
            <b-col v-for="(variant, i) in menuitem.variants" :key="i">
              <b>{{variant.name}}</b>
              <br />
              {{variant.price.toFixed(2)}} {{menuitem.currency}}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <variant
      :itemVariant="variant"
      :menuitem="menuitem"
      :filterTags="filterTags"
      v-for="(variant, i) in menuitem.variants"
      :key="i"
    ></variant>

    <!-- VARIANTS MODAL -->
    <b-modal
      :id="`variants-modal-${menuitem._id}`"
      :title="menuitem.name"
      ok-variant="danger"
      hide-footer
      centered
    >
      <b-card-group deck>
        <b-card
          border-variant="danger"
          :header="variant.name"
          header-bg-variant="danger"
          header-text-variant="white"
          align="center"
          v-for="(variant, i) in menuitem.variants"
          :key="i"
          @click="showVariant(variant, menuitem)"
          class="variant-card"
        >
          <b-card-text>{{variant.price.toFixed(2)}} {{menuitem.currency}}</b-card-text>
        </b-card>
      </b-card-group>
    </b-modal>

    <!-- ITEM MODAL -->
    <b-modal
      :id="menuitem._id"
      :ok-title="$t('Item.okTitle')"
      @ok="buildAndAddToCart(menuitem)"
      ok-variant="danger"
      :cancel-title="$t('Item.cancelTitle')"
      hide-header
      centered
    >
      <b-row class="text-center">
        <b-col>
          <b-img :src="menuitem.image" fluid />
        </b-col>
      </b-row>
      <b-row class="text-left" style="padding-top: 0.5rem;">
        <b-col>
          <h5>{{menuitem.name}}</h5>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col>
          <b-badge style="margin-right: 0.25em;" v-for="iflt in itemFilters" :key="iflt">{{iflt}}</b-badge>
        </b-col>
      </b-row>
      <b-form-group v-show="showThis.styles" :label="$t('Item.style')" class="text-left">
        <b-form-radio-group v-model="styleSelected" :options="styleOptions" name="stylesInline"></b-form-radio-group>
      </b-form-group>
      <b-form-group v-show="showThis.extras" :label="$t('Item.extras')" class="text-left">
        <b-form-checkbox-group
          stacked
          name="extras"
          v-model="extrasSelected"
          :options="extrasOptions"
        ></b-form-checkbox-group>
      </b-form-group>
      <div class="text-right">
        <h4>{{ $t('Item.price') }}: {{itemPrice.toFixed(2)}} {{menuitem.currency}}</h4>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
/* CONTROLLER */
import Variant from '@/components/Variant'
import { mapActions } from 'vuex'

export default {
  props: ['menuitem', 'filterTags'],
  components: {
    Variant
  },
  name: 'Item',
  data () {
    return {
      styleSelected: null,
      styleOptions: [],
      extrasSelected: [],
      extrasOptions: [],
      showThis: {
        styles: false,
        extras: false
      }
    }
  },
  mounted () {
    this.buildItem()
  },
  methods: {
    buildItem () {
      // build style radio buttons
      this.menuitem.styles.forEach((style, i) => {
        let newStyle = { text: style.name, value: style.name }
        this.styleOptions.push(newStyle)
        if (i === 0) this.styleSelected = style.name // auto-select first style
      })

      // build extras checkboxes
      this.menuitem.extras.forEach(extra => {
        let newExtra = {
          text: extra.name + ' (+' + extra.price.toFixed(2) + ')',
          value: extra.name
        }
        this.extrasOptions.push(newExtra)
      })
    },
    ...mapActions(['addToCart']),
    buildAndAddToCart (menuitem) {
      // build object and send to store
      let sendObject = {
        _id: this.menuitem._id,
        price: this.itemPrice,
        name: this.menuitem.name,
        currency: this.menuitem.currency,
        category: this.menuitem.category,
        extras: this.extrasSelected.sort(),
        style: this.styleSelected
      }
      this.addToCart(sendObject)
    },
    chooseModal (item) {
      item.variants === undefined || item.variants.length === 0
        ? this.$bvModal.show(item._id)
        : this.$bvModal.show(`variants-modal-${item._id}`)
    },
    showVariant (variant, item) {
      this.$bvModal.hide(`variants-modal-${item._id}`)
      this.$bvModal.show(variant._id)
    }
  },
  computed: {
    hasVariants () {
      if (
        this.menuitem.variants === undefined ||
        this.menuitem.variants.length === 0
      ) {
        return false
      } else return true
    },
    itemPrice: function () {
      let extrasPrice = 0
      this.extrasSelected.forEach(extra => {
        this.menuitem.extras.forEach(el => {
          if (extra === el.name) {
            extrasPrice += el.price
          }
        })
      })
      return this.menuitem.price + extrasPrice
    },
    itemFilters () {
      let itemFT = []
      if (this.filterTags) {
        this.filterTags.forEach(ft => {
          if (this.menuitem.tags.includes(ft.value)) itemFT.push(ft.text)
        })
      }
      return itemFT
    }
  },
  watch: {
    styleOptions () {
      if (this.styleOptions.length > 0) {
        this.showThis.styles = true
      } else {
        this.showThis.styles = false
      }
    },
    extrasOptions () {
      if (this.extrasOptions.length > 0) {
        this.showThis.extras = true
      } else {
        this.showThis.extras = false
      }
    },
    '$i18n.locale': {
      handler: function () {
        this.styleOptions = []
        this.extrasOptions = []
        this.buildItem()
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container-fluid {
  padding-right: 0px;
  padding-left: 0px;
}
img {
  padding-right: 0.5rem;
}
@media only screen and (max-width: 600px) {
  .card-body {
    padding: 0.5rem;
  }
}
.container-fluid:not(:first-child) {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.menu-item,
.variant-card {
  cursor: pointer;
}
.menu-item:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Item.vue